import * as React from 'react';
import { connect } from 'react-redux';
import { cn } from '../../../utils/ClassNamesUtils';
import { AgentPageContext } from '../../../types/agentHarness';
import { describeOscarEntity, OscarEntityDescription } from '../../utils/OscarEntityDescription';
import { oscarContextEntity } from '../../utils/OscarPageContext';

interface OscarContextSummaryOwnProps {
	context: AgentPageContext;
	/**
	 * The Share switch. Off, the copy stays the same and the summary greys out (secondary /
	 * disabled text) beside the switch, which shows the state.
	 */
	shared: boolean;
}

/** Flattened to strings so `connect`'s shallow compare skips unrelated store updates. */
interface OscarContextSummaryProps
	extends OscarContextSummaryOwnProps,
		Partial<OscarEntityDescription> {}

/**
 * The context bar's summary: "Sharing WO #34234 · <title>" over the record's location. The record
 * comes from the store (`describeOscarEntity`), so it fills in once its page has loaded it.
 */
const OscarContextSummaryBase = ({ shared, label, title, subtitle }: OscarContextSummaryProps) => {
	if (!label) return null;
	return (
		<div className="flex min-w-0 flex-col">
			<div
				className={cn(
					'bodyregular',
					shared ? 'text-character-primary' : 'text-character-secondary'
				)}
			>
				<span className="bodybold">Sharing {label}</span>
				{title ? ` · ${title}` : null}
			</div>
			{subtitle ? (
				<div
					className={cn(
						'footnoteregular',
						shared ? 'text-character-secondary' : 'text-character-disabled'
					)}
				>
					{subtitle}
				</div>
			) : null}
		</div>
	);
};

const mapStateToProps = (state: any, ownProps: OscarContextSummaryOwnProps) => {
	const entity = oscarContextEntity(ownProps.context);
	return entity ? describeOscarEntity(entity, state) : {};
};

export const OscarContextSummary = connect(mapStateToProps)(OscarContextSummaryBase);

export default OscarContextSummary;
